var map = {
	"./dash-PROG-STANDARD_full_white.png": "1344",
	"./dash-VARILUX-COMFORT_full_white.png": "fc58",
	"./dash-VARILUX-E-SERIES_full_white.png": "066b",
	"./dash-VARILUX-PHYSIO_full_white.png": "c365",
	"./dash-VARILUX-S-SERIES_full_white.png": "0c04",
	"./dash-VARILUX-X-SERIES_full_white.png": "9817"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a8a";